import { OrderedDate, SpecialHolidayType } from 'types/calendar'

export const FETCH_SPECIAL_HOLIDAYS = 'FETCH_SPECIAL_HOLIDAYS'
export const fetchSpecialHolidaysAction = (specialHolidays: SpecialHolidayType[]) => {
  return {
    type: 'FETCH_SPECIAL_HOLIDAYS',
    payload: specialHolidays,
  }
}

export const INIT_CALENDAR = 'INIT_CALENDAR'
export const initCalendarAction = () => {
  return {
    type: 'INIT_CALENDAR',
    payload: undefined,
  }
}

export const SET_ACTIVE_DATES = 'SET_ACTIVE_DATES'
export const setActiveDatesAction = (dates: Date[]) => {
  return {
    type: 'SET_ACTIVE_DATES',
    payload: dates,
  }
}

export const SET_CURRENT_DATE = 'SET_CURRENT_DATE'
export const setCurrentDateAction = (date: Date) => {
  return {
    type: 'SET_CURRENT_DATE',
    payload: date,
  }
}

export const SET_CURRENT_MONTH = 'SET_CURRENT_MONTH'
export const setCurrentMonthAction = (date: Date) => {
  return {
    type: 'SET_CURRENT_MONTH',
    payload: date,
  }
}
export const SET_CLOSED_DATES = 'SET_CLOSED_DATES'
export const setClosedDatesAction = (dates: Date[]) => {
  return {
    type: 'SET_CLOSED_DATES',
    payload: dates,
  }
}

export const SET_ORDERED_DATES = 'SET_ORDERED_DATES'
export const setOrderedDatesAction = (orderedDates: OrderedDate[]) => {
  return {
    type: 'SET_ORDERED_DATES',
    payload: orderedDates,
  }
}
